import React, { Component } from "react";
import { Form, Button, Modal } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import moment from "moment";
import DatePicker from "react-datepicker";

import { ROLES } from "../Users/roles";
import { WEBHOOK_TRIGGERS } from "./index";

const webhookForm = {
  appointment_id: "",
  dealer_location_id: "",
  wo_nr: "",
  communication_key: "",
  customer_dms_nr: "",
  customer_type: "",
  user_id: "",
  dealer_name: "",
  dealer_id: "",
  location_name: "",
  username: "",
  email: "",
  first_name: "",
  last_name: "",
  role: "",
  web_version: "",
  app_version: "",
  last_login: null,
  active: false,
  has_leased_tablet: false,
  is_combi_user: false,
  is_counter_tablet_user: false,
};

class WebhooksTestModal extends Component {
  state = {
    form: { ...webhookForm },
    hasErrors: false,
  };

  handleInputChange = e => {
    const { name, value } = e.target;
    this.setState(state => ({ form: { ...state.form, [name]: value } }));
  };

  handleCheckboxChange = (_, { name, checked }) => {
    this.setState(state => ({ form: { ...state.form, [name]: checked } }));
  };

  handleDropdownChange = (_, { name, value }) => {
    this.setState(state => ({ form: { ...state.form, [name]: value } }));
  };

  handleLastLoginChange = last_login => {
    this.setState(state => ({ form: { ...state.form, last_login } }));
  };

  handleCancel = () => {
    this.setState({ hasErrors: false });
    this.props.onCancel();
  };

  handleSubmit = () => {
    const { form } = this.state;
    const { onSubmit } = this.props;
    const isUserTrigger = this.props.webhook?.webhook_trigger_id === WEBHOOK_TRIGGERS.USER_TRIGGER;

    if (isUserTrigger && (!form.user_id || !form.dealer_location_id)) {
      this.setState({ hasErrors: true });
      return;
    }

    const payload = {
      appointment_id: form.appointment_id,
      dealer_location_id: form.dealer_location_id,
      wo_nr: form.wo_nr,
      communication_key: form.communication_key,
      customer_dms_nr: form.customer_dms_nr,
      customer_type: form.customer_type,
      webhook_trigger_id: this.props.webhook?.webhook_trigger_id,
    };

    if (isUserTrigger) {
      payload.user = {
        user_id: Number(form.user_id),
        dealer_location_id: Number(form.dealer_location_id),
        active: form.active,
        has_leased_tablet: form.has_leased_tablet,
        is_combi_user: form.is_combi_user,
        is_counter_tablet_user: form.is_counter_tablet_user,
        ...(form.dealer_name && { dealer_name: form.dealer_name }),
        ...(form.dealer_id && { dealer_id: Number(form.dealer_id) }),
        ...(form.location_name && { location_name: form.location_name }),
        ...(form.username && { username: form.username }),
        ...(form.email && { email: form.email }),
        ...(form.first_name && { first_name: form.first_name }),
        ...(form.last_name && { last_name: form.last_name }),
        ...(form.role && { role: form.role }),
        ...(form.web_version && { web_version: form.web_version }),
        ...(form.app_version && { app_version: form.app_version }),
        ...(form.last_login && { last_login: moment(form.last_login).toISOString() }),
      };
    }

    onSubmit(payload);
  };

  renderUserFields = () => {
    const { form, hasErrors } = this.state;
    const { t } = this.props;

    const roleOptions = Object.entries(ROLES).map(([name, id]) => ({
      key: id,
      value: id,
      text: t(name.toLowerCase()).message || name,
    }));

    return (
      <div>
        <Form.Group widths="equal">
          <Form.Field error={hasErrors && !form.user_id}>
            <Form.Input name="user_id" label={t("user_id").message || "User ID"} onChange={this.handleInputChange} value={form.user_id} />
          </Form.Field>
          <Form.Field>
            <Form.Dropdown
              name="role"
              label={t("role").message || "Role"}
              placeholder={t("role").message || "Role"}
              selection
              clearable
              options={roleOptions}
              value={form.role}
              onChange={this.handleDropdownChange}
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input name="first_name" label={t("first_name").message || "First Name"} onChange={this.handleInputChange} value={form.first_name} />
          </Form.Field>
          <Form.Field>
            <Form.Input name="last_name" label={t("last_name").message || "Last Name"} onChange={this.handleInputChange} value={form.last_name} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input name="username" label={t("username").message || "Username"} onChange={this.handleInputChange} value={form.username} />
          </Form.Field>
          <Form.Field>
            <Form.Input name="email" label={t("email").message || "Email"} onChange={this.handleInputChange} value={form.email} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input name="dealer_id" label={t("dealer_id").message || "Dealer ID"} onChange={this.handleInputChange} value={form.dealer_id} />
          </Form.Field>
          <Form.Field>
            <Form.Input name="dealer_name" label={t("dealer_name").message || "Dealer Name"} onChange={this.handleInputChange} value={form.dealer_name} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input name="location_name" label={t("location_name").message || "Location Name"} onChange={this.handleInputChange} value={form.location_name} />
          </Form.Field>
          <Form.Field>
            <label>{t("last_login").message || "Last Login"}</label>
            <DatePicker
              dateFormat="dd-MM-yyyy"
              placeholderText={t("last_login").message || "Last Login"}
              selected={form.last_login}
              onChange={this.handleLastLoginChange}
              showMonthDropdown
              showYearDropdown
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input name="web_version" label={t("web_version").message || "Web Version"} onChange={this.handleInputChange} value={form.web_version} />
          </Form.Field>
          <Form.Field>
            <Form.Input name="app_version" label={t("app_version").message || "App Version"} onChange={this.handleInputChange} value={form.app_version} />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Checkbox name="active" label={t("active").message || "Active"} checked={form.active} onChange={this.handleCheckboxChange} />
          </Form.Field>
          <Form.Field>
            <Form.Checkbox
              name="has_leased_tablet"
              label={t("has_leased_tablet").message || "Has Leased Tablet"}
              checked={form.has_leased_tablet}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>
          <Form.Field>
            <Form.Checkbox
              name="is_combi_user"
              label={t("is_combi_user").message || "Is Combi User"}
              checked={form.is_combi_user}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>
          <Form.Field>
            <Form.Checkbox
              name="is_counter_tablet_user"
              label={t("is_counter_tablet_user").message || "Is Counter Tablet User"}
              checked={form.is_counter_tablet_user}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>
        </Form.Group>
      </div>
    );
  };

  render() {
    const { webhook, renderAlert, isLoading, t } = this.props;
    const { form, hasErrors } = this.state;
    const isUserTrigger = webhook?.webhook_trigger_id === WEBHOOK_TRIGGERS.USER_TRIGGER;

    return (
      <div>
        <Modal className="WebhooksTestModal" open={!!webhook} onClose={this.handleCancel} closeOnDimmerClick={false}>
          <Modal.Header>{t("webhook_test").message || "Webhook Test"}</Modal.Header>
          <Modal.Content scrolling>
            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <Form.Input
                    name="appointment_id"
                    label={t("appointment_id").message || "Appointment ID"}
                    onChange={this.handleInputChange}
                    value={form.appointment_id}
                  />
                </Form.Field>
                <Form.Field error={isUserTrigger && hasErrors && !form.dealer_location_id}>
                  <Form.Input
                    name="dealer_location_id"
                    label={t("dealer_location_id").message || "Dealer Location ID"}
                    onChange={this.handleInputChange}
                    value={form.dealer_location_id}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Form.Input name="wo_nr" label={t("wo_number").message || "WO Number"} onChange={this.handleInputChange} value={form.wo_nr} />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    name="communication_key"
                    label={`${t("communication_key").message || "Communication Key"} (${
                      t("for_communication_triggers_only").message || "for communication triggers only"
                    })`}
                    onChange={this.handleInputChange}
                    value={form.communication_key}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <Form.Input
                    name="customer_dms_nr"
                    label={`${t("customer_dms_nr").message || "Customer DMS Number"} (${
                      t("for_communication_triggers_only").message || "for communication triggers only"
                    })`}
                    onChange={this.handleInputChange}
                    value={form.customer_dms_nr}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    name="customer_type"
                    label={`${t("customer_type").message || "Customer Type"} (${t("for_communication_triggers_only").message || "for communication triggers only"})`}
                    onChange={this.handleInputChange}
                    value={form.customer_type}
                  />
                </Form.Field>
              </Form.Group>
              {isUserTrigger && this.renderUserFields()}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button size="large" onClick={this.handleCancel} color="grey">
              {t("cancel").message || "Cancel"}
            </Button>
            <Button size="large" loading={isLoading} disabled={isLoading} onClick={this.handleSubmit} color="green">
              {t("submit").message || "Submit"}
            </Button>
          </Modal.Actions>

          {renderAlert()}
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(WebhooksTestModal);
